<section class="error-text {{ customClass }}"> <span class="icon-cr-error"></span> <span>&nbsp;{{ message }}</span> </section> 